import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/brand_experience.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function BrandExperience() {
    return (
        <Container className='digital'>
            <h2 className="text-center title">Brand Experience & Activation</h2>
            <Row>
                <div className='responsive-title'>Turning Ideas Into Impactful Moments</div>
            </Row>
            <Row className='mt-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                    <p className='text-center mb-4 content'>
                        In a world where attention is currency, your brand can’t afford to be forgettable. We help you create branded experiences that don’t just impress they resonate. From large scale events to agile digital campaigns, we blend storytelling, tech, and execution to bring your brand to life on any screen, and in any space.

                    </p>
                    <p className='text-center mb-4 content'>
                        Whether you're building buzz or building loyalty, we design every touchpoint to move hearts and trigger action.
                    </p>
                </AnimationOnScroll>
            </Row>

            <Row>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.5} offset={100}>
                        <div className='mb-4 box'>
                            <div className='mb-4 box-title'>
                                What We Activate:
                            </div>
                            <Row>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Customer Engagement Services</h4>
                                    <p>Strategies and programs that spark conversation, build communities, and deepen loyalty.</p>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Event Management Platforms</h4>
                                    <p>End-to-end tools to plan, promote, and run events live, virtual, or hybrid without chaos.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Campaign Execution (Digital & On-Ground)</h4>
                                    <p>From pixels to pop-ups, we bring your creative ideas to life with precision and purpose</p>
                                </div>
                            </Row>
                        </div>
                    </AnimationOnScroll>
                </Col>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__flipInX" duration={.5} offset={100}>
                        <img src={img01} alt="Telecom Innovation Stack" className='img-fluid' style={{ width: '100%', height: 'auto', borderRadius: '50px' }} />
                    </AnimationOnScroll>
                </Col>


            </Row>


        </Container>
    )

}